import { Stake } from '../../interfaces/utils';

export const mockFeaturedStakes: Stake[] = [1, 5, 10];
